import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { HTMLParser, Image, KeepProportions, SvgIcon, Wide } from '@gik/ui';
import { Product } from '@gik/core/models/gik/Product';
import noop from '@gik/core/utils/noop';

export interface IGiftCardTileProps extends React.HTMLAttributes<HTMLDivElement> {
  giftcard: Product;
  addButton?: boolean;
  deleteButton?: boolean;
  selected?: boolean;
  onAdd?: (giftcard: Product) => void;
  onDelete?: (giftcard: Product) => void;
  onClickItem?: (giftcard: Product) => void;
}

export function GiftCardTile({
  giftcard,
  addButton,
  deleteButton,
  className,
  selected,
  onAdd = noop,
  onDelete = noop,
  onClickItem = noop,
  ...otherProps
}: IGiftCardTileProps): React.ReactElement {
  const bem = bemBlock('gift-card-tile');

  return (
    <div className={bem(null, [{ selected }], className)} {...otherProps}>
      <div className={bem('border')} />
      <div className={bem('inner')} onClick={() => onClickItem(giftcard)}>
        <KeepProportions proportion={Wide}>
          <Image draggable={false} src={giftcard.thumbnails && giftcard.thumbnails[0]} />
        </KeepProportions>
        <span className={bem('label')}>{HTMLParser({ rawHtml: giftcard.name })}</span>

        {addButton && (
          <div
            className={bem('button', ['add'])}
            onClick={ev => {
              ev.stopPropagation();
              onAdd(giftcard);
            }}
          >
            <SvgIcon name="Plus" />
          </div>
        )}

        {deleteButton && (
          <div
            className={bem('button', ['delete'])}
            onClick={ev => {
              ev.stopPropagation();
              onDelete(giftcard);
            }}
          >
            <SvgIcon name="Trash" />
          </div>
        )}
      </div>
    </div>
  );
}
